<template>
  <VaCard stripe stripe-color="success">
    <VaCardTitle>
    Стационар
    </VaCardTitle>
    
    <VaCardContent>
      <div class="rcflex row rcflex-btw">
      <VaButtonToggle
        v-model="filter"
        preset="secondary"
        :options="filters"
        class="mb-2"
        :disabled="search.length>0"
      />
      <VaButtonToggle
        v-model="myown"
        preset="secondary"
        :options="ownfilter"
        class="mb-2"
        :disabled="search.length>0"
      />
      </div>
      <div class="rcflex row vcenter">
        <VaInput class="mb-2" style="width:100%" v-model="search" placeholder="Начните набирать фамилию, имя или отчество пациента">
          <template #prepend>
            Поиск
          </template>
          <template #appendInner>
            <VaIcon v-if="search.length>0" @click="search=''" name="clear" color="primary"/>
            <VaIcon name="search" color="primary"/>
          </template>
        </VaInput>
        </div>
      <VaDataTable
        :loading="loading"
        clickable
        :items="medhistory" 
        :columns="columns" 
        sticky-header
        :noDataHtml="loading ? 'Загрузка' : 'Записей не найдено'"
        @row:click="gotoMH"
      >
      <template #cell(patient_full_name)="{ rowData }">
        {{ rowData.patient_full_name }}{{ rowData.patient_birthdate ? ', ' + rowData.patient_birthdate.split('-').reverse().join('.') : ''}}<br/>
        <VaChip size="small" :color="rowData.closed ? 'warning' : 'success'">{{ rowData.closed ? 'Закрыта '+rowData.closeDate : 'Открыта' }}</VaChip>
        <VaChip size="small" color="warning" class="ml-2" v-if="rowData.comments_count.length>0">Есть комментарии</VaChip>
        <VaChip size="small" color="secondary" class="ml-2" v-if="rowData.transfer">На передаче</VaChip>
        <VaChip size="small" color="#8f97cf" style="color:#ffffff" class="ml-2" v-if="!rowData.discharged">В стационаре с {{ rowData.openDate }}</VaChip>
        <VaChip size="small" color="success" class="ml-2" v-else>Выписан {{ rowData.discharge_date }}</VaChip>
      </template>
      <template #cell(doctor_full_name)="{ rowData }">
        {{ reduce(rowData.doctor_full_name) }}
      </template>
        <template #cell(actions)="{ row, rowData, isExpanded }">
          <VaButton v-show="false"
            :icon="isExpanded ? 'va-arrow-up': 'va-arrow-down'"
            preset="primary"
            class="w-full"
            @click="row.toggleRowDetails()"
          />
          <VaButton
            icon="quick_reference_all"
            preset="primary"
            class="w-full ml-2"
            @click="$router.push('/medhistory/' + rowData.id)"
          />
        </template>
        <template #cell(paid)="{ rowData }">
          <VaIcon
            :name="rowData.paid ? 'attach_money' : 'cruelty_free'"
            :color="rowData.paid ? 'success' : 'primary'"
            
            class="w-full ml-2"
            text="asd"
          />
           
        </template>

        <template #expandableRow="{ rowData }">
          <VaAlert
            color="primary"
            border="left"
          >
            <template #icon>
              <VaIcon name="info" />
            </template>
            <div class="rcflex column ml-2 mt-2">
              <div class="rcflex mb-2">
                <span>Оплата: {{ rowData.paid ? 'Платный' : "КСГ" }}</span>
              </div>
              <div class="rcflex mb-2">
                <span>Врач: {{ rowData.doctor_full_name }}</span>
              </div>
              <div class="rcflex mb-2">
                <span>Палата: {{ rowData.room }}</span>
              </div>
              <div class="rcflex mb-2">
                <span>Поступление: {{ rowData.openDate }}</span>
              </div>
              <div class="rcflex">
                <span>Выписка: {{ rowData.discharged ? rowData.discharge_date : "нет" }}</span>
              </div>
            </div>
          </VaAlert>
        </template>
      </VaDataTable>
    </VaCardContent>
        <VaPagination
    v-if="totalPages > 1"
    v-model="currentPage"
    :pages="totalPages"
    :visible-pages="4"
    buttons-preset="secondary"
    class="justify-center sm:justify-start mb-4"
  />
  </VaCard>
</template>
<script>
import axiosInstance from "../services/api";
import EventBus from "../common/EventBus";
import { RouterLink } from 'vue-router'
import PatientProfile from '@/components/PatientProfile'
import debounce from 'lodash.debounce'

export default {
    components: { RouterLink, PatientProfile },
    data() {
        return {
            search: '',
            filters: [
              { label: "Все", value: "all" },
              { label: "Открытые", value: "open" },
              { label: "На проверке", value: "closed" },
              { label: "Архив", value: "accepted" },
            ],
            ownfilter: [
              { label: "Все", value: false },
              { label: "Только мои", value: true },
            ],
            columns: [
              { key: "id", label: "Номер", width: 1 },
              { key: "patient_full_name", label: "ФИО пациента", width: 10 },
              { key: "doctor_full_name", label: "Лечащий врач", width: 100 },
              { key: "room", label: "Палата", width: 10 },
              { key: "paid", label: "Оплата", width: 10 },
              { key: "actions", label: "Действия", width: 100 },
            ],
            medhistory: [],
            patient: {},
            filter: 'all',
            myown: false,
            medhistoryCount: Number,
            currentPage: 1,
            loading: false,
          };
    },
    watch: {      
      currentPage: function(newValue){
        this.getMedhistoryList(this.$store.state.app.account.profile.id,this.filter,newValue,this.myown)
      },
      filter: function(newValue){
        this.getMedhistoryList(this.$store.state.app.account.profile.id,newValue,1,this.myown)
      },
      myown: function(newValue){
        this.getMedhistoryList(this.$store.state.app.account.profile.id,this.filter,1,newValue)
      },
      search: function (newValue) {
        if (!this.tooShortQuery) {
          this.filter = 'all'
          this.myown = false
          this.debouncedSearch()
        }
      },

//      search: function(newValue){
//        this.getMedhistoryList(this.$store.state.app.account.profile.id,this.filter,1,newValue)
//      },
    },
    computed: {
      tooShortQuery() {
        return this.search.length !== 0 && this.search.length<3 ? true : false 
      },
      /*filtered() {
        var iam = this.$store.state.app.account.profile.id
        if (this.filter === 'open') {
          if (this.myown) {
            return this.medhistory.filter(item => item.closed === false && item.accepted === false && item.user === iam && item.patient_full_name.toLowerCase().includes(this.search.toLowerCase()))
          }else{
            return this.medhistory.filter(item => item.closed === false && item.patient_full_name.toLowerCase().includes(this.search.toLowerCase()))
          }
        }
        else if (this.filter === 'closed') {
          if (this.myown) {
            return this.medhistory.filter(item => item.closed === true && item.accepted === false && item.user === iam && item.patient_full_name.toLowerCase().includes(this.search.toLowerCase()))
          }else{
            return this.medhistory.filter(item => item.closed === true  && item.accepted === false && item.patient_full_name.toLowerCase().includes(this.search.toLowerCase()))
          }
        }
        else if (this.filter === 'accepted') {
          if (this.myown) {
            return this.medhistory.filter(item =>item.accepted === true && item.user === iam && item.patient_full_name.toLowerCase().includes(this.search.toLowerCase()))
          }else{
            return this.medhistory.filter(item => item.accepted === true && item.patient_full_name.toLowerCase().includes(this.search.toLowerCase()))
          }
        }
      },
      ownfiltered() {
        if (this.filter === 'all') {
          return this.filtered
        }
        if (this.filter === 'myown') {
          return this.filtered.filter(item => item.user === this.$store.state.app.account.profile.id)
        }
      },*/
      totalPages() {
        return Math.ceil(this.medhistoryCount / 20)
      },
    },
    methods: {
      gotoMH(row) {
        this.$router.push('/medhistory/' + row.item.id)
      },
      reduce(string) {
        return string.split(' ')[0] + ' ' + string.split(' ')[1].substring(0,1) + '. ' + string.split(' ')[2].substring(0,1) + '.'
      },
      debouncedSearch: debounce(function () {
              this.getMedhistoryList(this.$store.state.app.account.profile.id,this.filter,1,this.myown);
            }, 600),
      getMedhistoryList(user,filter,page,ownfilter) {
        this.loading = true
        let q = ''
        if (this.search.length > 0) {
          q = '&query='+this.search
        }
         
        axiosInstance
            .get(`/medhistory/?user=`+user+`&filter=`+filter+`&page=`+page+`&myown=`+ownfilter+q)
            .then(response => {
                this.medhistoryCount = response.data.count
                this.medhistory = response.data.results
            })
            .catch(error => {
              console.log('Templates: error ' + error);
        })
            .finally(() => {
              console.log('Templates: Request completed')
              //this.getPatient(this.medhistory.patient)
              this.loading = false
        });
      },
      getPatient(id) {
            axiosInstance
                .get(`patients/`+id+`/`)
                .then(response => {
                  this.patient = response.data;
            })
                .catch(error => {
                this.getPatientError = true;
            })
          },
    },
    created() {
      !this.$store.state.auth.status.loggedIn && this.$router.push('/login')
    },
    mounted() {
      this.getMedhistoryList(this.$store.state.app.account.profile.id,'all',1,'false')
    },
}

</script>
<style>
</style>